import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import type { StageCreateInDto } from 'shared/domain/workflow/types';
import type { StageCreateRequestModel } from '../httpQueue/workflow/stageRequestRunner';

export interface AddStageUseCase {
  execute(
    stageCreateDto: StageCreateInDto,
    workflowId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void>;
}

export class StageSaver implements AddStageUseCase {
  constructor(
    private addRequest: (request: StageCreateRequestModel) => Promise<unknown>
  ) {}

  async execute(
    stageCreateDto: StageCreateInDto,
    workflowId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    debugLog('StageSaver.execute', stageCreateDto);
    const request: StageCreateRequestModel = {
      createdAt: Date.now(),
      method: 'POST',
      url: `/project/${projectId}/workflow/${workflowId}/stage`,
      data: {
        stageCreateDto,
        workflowId,
        projectId,
        uniqueId,
      },
      entityType: HttpRequestModelType.workflowStage,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const stageSaver = new StageSaver(addRequest);
